import React from 'react';
import { Linkedin, Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-slate-300 py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <img 
                src="/2besales-logo.png" 
                alt="2besales Logo" 
                className="h-8 w-auto brightness-0 invert"
              />
            </div>
            <p className="text-slate-400 leading-relaxed">
              Dein Partner für professionelle LinkedIn-Akquise und Neukundengewinnung.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><a href="#benefits" className="hover:text-blue-400 transition-colors">Vorteile</a></li>
              <li><a href="#process" className="hover:text-blue-400 transition-colors">Prozess</a></li>
              <li><a href="#testimonials" className="hover:text-blue-400 transition-colors">Testimonials</a></li>
              <li><a href="#contact" className="hover:text-blue-400 transition-colors">Kontakt</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4">Rechtliches</h3>
            <ul className="space-y-2">
              <li><a href="https://www.2besales.de/impressum" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors">Impressum</a></li>
              <li><a href="https://www.2besales.de/datenschutz" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors">Datenschutz</a></li>
              <li><a href="https://www.2besales.de/agb" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors">AGB</a></li>
              <li><a href="https://www.2besales.de/disclaimer" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors">Disclaimer</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">Kontakt</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-blue-400" />
                <a href="mailto:info@2besales.de" className="hover:text-blue-400 transition-colors">
                  info@2besales.de
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Linkedin className="w-4 h-4 text-blue-400" />
                <a href="https://www.linkedin.com/company/2besales" target="_blank" rel="noopener noreferrer" className="hover:text-blue-400 transition-colors">
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-slate-800 text-center text-slate-500">
          <p>© {currentYear} 2besales GmbH - Alle Rechte vorbehalten</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
